import React from 'react';
import { Link } from 'react-router-dom';
import Chapters from '../../data/header/Chapters.json';
import Navmenu from '../../data/header/navmenu.json';
import News from '../../data/header/News.json';
const chapters = Chapters;
const navmenu = Navmenu;
const news = News;
const Nav = () => {
    return (
        <ul className="mainmenu">
            {navmenu.map((data, index) => (
                <li className="has-droupdown" key={index}>
                    <Link to={data.link}>{data.name}</Link>
                    {data.name == 'News' ? (
                        <ul className="submenu">
                            {news.map((data, index) => (
                                <li key={index}>
                                    <Link to={data.link}>{data.name}</Link>
                                </li>
                            ))}
                        </ul>
                    ) : null}
                    {data.name == 'Chapters' ? (
                        <ul className="submenu">
                            {chapters.map((data, index) => (
                                <li key={index}>
                                    <Link to={data.link}>{data.name}</Link>
                                </li>
                            ))}
                        </ul>
                    ) : null}
                </li>
            ))}
        </ul>
    );
};
export default Nav;
